"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useForwardedRef", {
    enumerable: true,
    get: function() {
        return useForwardedRef;
    }
});
const _react = require("react");
const useForwardedRef = (ref)=>{
    const innerRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (ref == null) {
            return;
        }
        if (typeof ref === "function") {
            ref(innerRef.current);
        } else {
            ref.current = innerRef.current;
        }
    });
    return innerRef;
};

//# sourceMappingURL=useForwardedRef.js.map